<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12">
        <b-card>
          <div slot="header"><i class="icon-note"></i> Libro Mayor
            <i @click="visible = !visible" style="cursor: pointer;" :class="{ 'fa fa-angle-up pull-right': visible, 'fa fa-angle-down pull-right': !visible }"> </i>            
          </div>
          
          <b-collapse v-model="visible">
          <b-row class="cuerpo">
            <b-col cols="11" col md="2" class="pr-6">
              <label for="desde"> Mes:&nbsp; </label><br />
              <date-picker
                id="desde"
                v-model="filtros.mes"
                type="month"
                format="MM/YYYY"
                :lang="lang"
                :editable="false"
                style="width: 110%"
                :disabled="cargandoDatos"
              >
              </date-picker>
            </b-col>

           <!-- <b-col cols="12" col md="2">
              <b-form-group id="input-group-1" label="Área:">
                <b-form-select
                  v-model="filtros.area"
                  :options="areasoptions"
                  value-field="id"
                  text-field="nombre"
                  @change="centrosArea"
                  style="min-width: 80px"
                  :disabled="cargandoDatos"
                ></b-form-select>
              </b-form-group>
            </b-col> -->
         <!--   <b-col cols="12" col md="2">
              <b-form-group label="Centro:">
                <b-input-group>
                  <b-form-select
                    v-model="filtros.centro_id"
                    :options="centros"
                    value-field="id"
                    text-field="nombre"
                    class="mb-3"
                    style="min-width: 80px"
                  >
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </b-col> -->
            <b-col cols="12" col md="2">
              <b-form-group label="Nivel">
                <b-input-group>
                  <b-form-select
                    v-model="filtros.nivel"
                    :options="niveles"
                    value-field="id"
                    text-field="nombre"
                    class="mb-3"
                    style="width: 60%"
                  >
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="6" col md="3" ml-md="4">
              <button
                class="btn btn-sm btn-success text-white mr-1 mt-4"
                @click="cargarDatos('n')"
                style="margin-top: 0.4em"
                :disabled="cargandoDatos"
              >
                <i class="fa fa-search"></i> Cargar Datos
              </button>

          <!--    <button
               v-show="registros.length"
                class="mt-4 btn btn-sm btn-success text-white"
                @click="cargarDatos('s')"
                style="margin-top: 0.4em"
                :disabled="cargandoDatos"
              >
                <i class="fa fa-file-excel-o"></i> Exportar Excel
              </button> -->
            </b-col>
          </b-row>
          </b-collapse>
        </b-card>
      </b-col>
    </b-row>

    <b-row v-show="!registros.length">
      <b-col cols="12">
        <b-card>
          <p class="cuerpo text-center" style="margin: 0">
            {{
              yaSeRealizoPrimeraBusqueda
                ? "No hay datos disponibles."
                : "Seleccione un periodo"
            }}
          </p>
        </b-card>
      </b-col>
    </b-row>
    <section v-show="cargandoDatos">
      <b-row>
        <img
          class="mx-auto"
          src="/img/loader.svg"
          style="width: 128px"
          alt="Cargando..."
        />
      </b-row>
      <b-row>
        <p class="text-primary mx-auto">Por favor espere...</p>
      </b-row>
    </section>
    <b-row
      v-show="(registros.length || yaSeRealizoPrimeraBusqueda) && !cargandoDatos"
    >
      <b-col cols="12">
        <b-card>
          <div class="cuerpo">
          <b-col class="table-responsive" style="padding: 0">
            <table rules="all" class="borde table-hover" style="width: 100%">
              <thead>
                <tr style="background-color: #fbfcfc">
                  <th
                    colspan="2"
                    style="width: 5%; vertical-align: bottom"
                    class="text-info negrita"
                  >
                    &nbsp; Cuenta:<br />
                    <input
                      class="form-control form-sm input-sm"
                      type="text"
                      v-model.trim="filtros.cuenta"
                      @change="cargarDatos()"
                      style="width: 85%"
                    />
                  </th>
                  <th
                    style="width: 20%; vertical-align: bottom"
                    class="text-info negrita"
                  >
                    &nbsp; Descripcion Cuenta:<br />
                    <input
                      class="form-control form-sm input-sm"
                      type="text"
                      v-model.trim="filtros.nombre"
                      @change="cargarDatos()"
                      style="width: 85%"
                    />
                  </th>
                  <th
                    v-show="filtros.centro_id"
                    class="text-center text-info negrita"
                    style="width: 10%"
                  >
                    Centro:<br />
                    <input
                      class="form-control form-sm input-sm"
                      type="text"
                      v-model.trim="filtros.centro"
                      @change="cargarDatos()"
                      style="width: 85%"
                    />
                  </th>
                  <th class="text-center text-info negrita" style="width: 10%">
                    Saldo Inicial:<br />
                    <input
                      class="form-control form-sm input-sm"
                      type="text"
                      v-model.trim="filtros.inicial"
                      @change="cargarDatos()"
                      style="width: 85%"
                    />
                  </th>
                  <th
                    class="text-info negrita text-right text-center"
                    style="width: 10%"
                  >
                    Debe<br />

                    <input
                      class="form-control form-sm input-sm"
                      type="text"
                      v-model.trim="filtros.debe"
                      @change="cargarDatos()"
                      style="width: 85%"
                    />
                  </th>
                  <th
                    class="text-info negrita text-right text-center"
                    style="width: 10%"
                  >
                    Haber<br />

                    <input
                      class="form-control form-sm input-sm"
                      type="text"
                      v-model.trim="filtros.haber"
                      @change="cargarDatos()"
                      style="width: 85%"
                    />
                  </th>
                  <td
                    class="text-center negrita text-info"
                    rowspan="2"
                    style="width: 10%"
                  >
                    Saldo Final<br />
                    <input
                      class="form-control form-sm input-sm"
                      type="text"
                      v-model.trim="filtros.saldo"
                      @change="cargarDatos()"
                      style="width: 85%"
                    />
                  </td>
                </tr>
              </thead>
              <tbody v-for="(r, index) in registros" :key="index">
                <tr>
                  <td colspan="2" v-bind:class="{ pl: !r.detalles.length }">
                    <span style="cursor: pointer">
                      <i
                        v-show="r.detalles.length > 0"
                        v-bind:class="{
                          'fa fa-minus-square': !r.ocultar,
                          'fa fa-plus-square': r.ocultar,
                        }"
                        @click="toogleDetalle(r)"
                      ></i
                    ></span>
                    {{ r.cuenta }}
                  </td>
                  <td v-text="r.cuenta_nombre"></td>
                  <td
                    class="text-center"
                    v-text="r.centro"
                    v-show="filtros.centro_id"
                  ></td>
                  <td class="text-right">
                    {{
                      r.inicial | currency("", 2, { thousandsSeparator: "," })
                    }}
                  </td>
                  <td class="text-right">
                    {{ r.debe | currency("", 2, { thousandsSeparator: "," }) }}
                  </td>
                  <td class="text-right">
                    {{ r.haber | currency("", 2, { thousandsSeparator: "," }) }}
                  </td>
                  <td class="text-right">
                    {{ r.saldo | currency("", 2, { thousandsSeparator: "," }) }}
                  </td>
                </tr>
                <tr v-for="(d, index) in r.detalles" :key="`i-${index}`">
                  <td :colspan="vcolspan" v-show="!r.ocultar">
                    <table
                      style="width: 100%; padding: 0; margin: 0"
                      class="table-hover"
                    >
                      <tr v-show="index == 0">
                        <th class="text-center">
                          <i><small>Fecha:</small></i>
                        </th>
                       <!-- <th class="text-center">
                          <i><small>Centro:</small></i>
                        </th>-->
                        <th colspan="3" class="text-center">
                          <i><small>Codigo:</small></i>
                        </th>
                        <th v-show="filtros.centro_id"></th>
                        <th></th>
                        <th></th>
                      </tr>
                      <tr>
                        <td class="text-center">{{ d.fecha }}</td>
                      <!--  <td class="text-center">{{ d.centro }}</td> -->
                        <td colspan="3" class="text-center">
                          <b-link target="_blank"  :to="{ name: 'pdf-comprobante',  params: {id: d.id, name: d.codigo }}">{{ d.codigo }}</b-link>
                         </td>
                        <td v-show="filtros.centro_id"></td>

                        <td style="width: 14%" class="text-right">
                          {{
                            d.debito
                              | currency("", 2, { thousandsSeparator: "," })
                          }}
                        </td>
                        <td style="width: 14%" class="text-right">
                          {{
                            d.credito
                              | currency("", 2, { thousandsSeparator: "," })
                          }}
                        </td>
                        <td></td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </b-col>
        </div>
          <div class="pull-right">
            <small>
              Mostrando <strong>{{ registros.length }}</strong> de
              <strong>{{ totalRows }}</strong> Registros
            </small>
          </div>
          <br />
          <b-pagination
            :hidden="totalRows < filtros.pagesize"
            class="pull-right"
            :disabled="cargandoDatos"
            v-model="filtros.currentPage"
            :total-rows="totalRows"
            :per-page="filtros.pagesize"
          ></b-pagination>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Vue2Filters from "vue2-filters";
import toastr from "toastr";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/es";
import { cambiarFormatoFecha } from "../../shared/utils";

export default {
  mixins: [Vue2Filters.mixin],
  name: "LDiario-form",
  components: { DatePicker },
  mounted() {
    this.cargarCentros();
  },
  data: () => {
    return {
      filtros: {
        empresa_id:undefined,
        pagesize: 50,
        currentPage: 1,
        tipoComprobante: undefined,
        centro_id: undefined,
        area: undefined,
        mes: undefined,
        cuenta: undefined,
        cuenta_nombre: undefined,
        nivel: undefined,
        centro: undefined,
        inicial: undefined,
        debe: undefined,
        haber: undefined,
        saldo: undefined,
        excel: "n",
      },
      lang: { formatLocale: { firstDayOfWeek: 1 } },
      cargandoDatos: false,
      registros: [],
      totalRows: 0,
      centros: [],
      niveles: [],
      yaSeRealizoPrimeraBusqueda: false,
      visible:true,
    };
  },
  watch: {
    "filtros.currentPage": {
      handler: function () {
        this.cargarDatos();
      },
    },
  },
  methods: {
    toogleDetalle(detalle) {
      if (detalle.ocultar) detalle.ocultar = false;
      else detalle.ocultar = true;
    },
    formatoNumero(num, dec = 2) {
      return num && !isNaN(num)
        ? num.toFixed(dec).replace(/\d(?=(\d{3})+\.)/g, "$&,")
        : 0;
    },
    mostrar(registro) {
      registro.ocultar = !registro.ocultar;
    },
    formatoFecha(date) {
      // eslint-disable-next-line no-undef
      return moment(date).format("YYYY-MM-DD");
    },
    async cargarCentros() {
      try {

        let model ={};
        model.empresa_id = this.empresaId;
/*
        // eslint-disable-next-line no-undef
        const {data} = await axios.post("/api/catalogos/centros",{
          model
        });
        this.centros = data && data.data ? data.data : [];
        this.centros.unshift({ id: undefined, nombre: "Todos" });
*/
        this.niveles = [];
        // eslint-disable-next-line no-undef
        let niveles = await axios.post("/api/catalogos/niveles",{
          empresa_id : this.empresaId
        });

        for (let n of niveles.data) {
          this.niveles.push({ id: n, nombre: n });
        }
        this.niveles.unshift({ id: undefined, nombre: "Todos" });
      } catch (error) {
        console.log(error);
      }
    },
    async cargarDatos(excel = "n") {
      let vm = this;

      if (vm.filtros && !vm.filtros.mes)
        return toastr["warning"]("Favor seleccion un mes valido");

      vm.yaSeRealizoPrimeraBusqueda = true;

      vm.filtros.excel = excel;
      vm.cargandoDatos = true;
      vm.filtros.empresa_id = this.empresaId;
      try {
        let filtros = vm.filtros;

        // eslint-disable-next-line no-undef
        let {data} = await axios.post("/api/reportes/lmayor", filtros);
        if (excel == "s") {
          toastr["info"]("Generando Excel. Favor Espere");

        } else {
          vm.registros = [];
          vm.totalRows = data && data.total ? data.total : 0;
          let registros = data.data;
          registros.forEach((r) => {
            r.ocultar = true;
            r.detalles.forEach((d) => {
              d.fecha = cambiarFormatoFecha(d.fecha);
            });
            vm.registros.push(r);
          });

          if (vm.totalRows < vm.filtros.pagesize)
            vm.filtros.pagesize = vm.totalRows;
          else vm.filtros.pagesize = 50;
        }
      } catch (error) {
        console.log(error);
      }
      vm.cargandoDatos = false;
    },
  },
    computed: {
    ...mapGetters("authentication", ["empresaId"]),
    vcolspan(){
      if(this.filtros.centro_id)
        return 7;
      return 6;
    },
  },
};
</script>
<style scoped>
.negrita {
  font-weight: bold;
}
.debe_haber {
  width: 200px;
}
.table td {
  padding: 0;
  margin: 0;
}
.borde {
  border: solid #dde0e2;
  border-width: 0.35px 0.35px 0.35px;
}
.pl {
  padding-left: 1rem !important;
}
.card-body{
  padding:0;
}
.cuerpo{
  padding:1.25rem;
}
</style>
